// extracted by mini-css-extract-plugin
module.exports = {"promoCodeInput":"PromoCodeInput_promoCodeInput___2W2U"};